import styled from 'styled-components';
import { StyledRteHtmlText } from '../../../../../../../inputs/rich-text/style/StyledRteHtmlText.tsx';

export const HtmlInlineText = styled.div`
  &&& {
    ${StyledRteHtmlText};
    font-size: 16px;
    line-height: 1.3;
    margin: 0;
    > p {
      margin: 0;
    }
  }
`;
